import * as Sentry from "@sentry/react";
import { ReleaseAutoReload, useIsReloadDirty } from "@simplicity/ui";
import { useIsMutating } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * SIM-1670: auto-reloads the tab once a newer build is served, when the user is idle or the tab is
 * hidden. Blocked while a form is dirty (the SimplySpark editor with unsaved edits) or a mutation
 * is in flight; the read-only viewer registers nothing dirty, so it still reloads. In local dev the
 * `build-id` meta tag is empty, so this is a no-op.
 */
export function ReleaseWatcher() {
  const dirty = useIsReloadDirty();
  const mutating = useIsMutating() > 0;
  const reloadBlocked = dirty || mutating;

  const onNewVersionAvailable = useCallback((info: { from: string; to: string }) => {
    console.info("[release] new version detected", info);
  }, []);

  const onBeforeReload = useCallback((info: { from: string; to: string }) => {
    Sentry.addBreadcrumb({
      category: "release",
      message: "auto-reload",
      level: "info",
      data: info,
    });
  }, []);

  return (
    <ReleaseAutoReload
      reloadBlocked={reloadBlocked}
      onNewVersionAvailable={onNewVersionAvailable}
      onBeforeReload={onBeforeReload}
    />
  );
}
